import { faWandMagicSparkles } from '@fortawesome/pro-solid-svg-icons'
import type { IntlShape } from 'react-intl'

import type { CombinedListingSearchResult } from '@/queries/CombinedListingSearchResult'

import {
  trackActionPanelActionClicked,
  trackManifestQuickView,
  type AnalyticsTracker,
} from '../../helpers/listViewAnalytics'
import type { ListViewSurface } from '../../helpers/listViewSurface'
import { PANEL_ACTION_ORDER } from '../panelActionOrder'
import type { PanelActionDefinition } from '../types'

const ns = 'Listings.ListView.actionPanel.aiSummary'

/**
 * Open the row's manifest summary over the list.
 *
 * No auth gate. Rows with no summary render disabled, off the search result's
 * own flag, so no request is needed to know. The popup's empty state stays as
 * the fallback for a stale flag.
 *
 * [Perf] This runs for each row and we want it to be fast, so it has no hooks.
 */
export const createAiSummaryPanelAction = ({
  formatMessage,
  surface,
  tracker,
  openSummary,
}: {
  formatMessage: IntlShape['formatMessage']
  surface?: ListViewSurface
  tracker: AnalyticsTracker
  openSummary: (listing: CombinedListingSearchResult) => void
}): PanelActionDefinition => ({
  id: 'aiSummary',
  icon: faWandMagicSparkles,
  label: formatMessage({ id: `${ns}.label` }),
  description: formatMessage({ id: `${ns}.description` }),
  order: PANEL_ACTION_ORDER.aiSummary,
  isAvailable: (listing) => listing.hasManifestSummary,
  onClick: (listing) => {
    trackManifestQuickView(tracker, { listingId: listing.listingId, surface })
    trackActionPanelActionClicked(tracker, {
      action: 'ai_summary',
      listingId: listing.listingId,
      surface,
    })

    openSummary(listing)
  },
})
